<template>
  <div data-grm-comp="RoomCBTQuestionChoice" :id="`question_${index + 1}`" class="py-2 flex relative">
    <span class="w-20 py-5 px-2 text-3xl leading-relaxed absolute transform -translate-y-3 lg:px-6 lg:translate-y-0">{{ index + 1 }}</span>
    <div class="min-w-0 pl-14 py-1 flex-1 lg:pl-20">
      <div class="-ml-20 pl-20 flex items-start gap-x-1">
        <div class="relative">
          <div v-if="question.correctAnswerCnt > 1" class="w-max absolute -top-5">
            <p class="text-xs text-red-400">{{ $t("exam.question.score", { '0' : question.correctAnswerCnt }) }}</p>
          </div>
        </div>
        <div class="flex items-center gap-x-0.5">
          <GrmTextField type="number" v-model="question.questionScore" class="w-12" size="xs" disabled />
          <span class="text-xs">{{ $t("exam.question.point") }}</span>
        </div>
      </div>
      <div class="mt-2 flex flex-col gap-y-1 relative">
        <div v-for="(answer, i) in question.answerList"
             :key="i"
             class="gap-x-1"
        >
          <div class="min-w-0 max-w-max flex-1 rounded py-1 flex items-baseline gap-x-2">
            <div class="relative">
              <div class="w-4 h-4 border rounded-full flex justify-center items-center text-sm select-none transition pointer-events-none"
                      :class="[
                        answer.correct && showAnswer ? 'border-blue-400 bg-blue-400 text-white' : 'border-gray-800',
                      ]"
              >{{ i+1 }}</div>
              <span v-if="false" class="w-4 h-4 bg-cbt-check-red block absolute -top-2.5 -left-0.5 pointer-events-none" />
            </div>
            <div class="flex flex-col gap-y-2">
              <div class="flex flex-wrap gap-2">
                <div v-for="(submitUser, i) in submitUserList(answer)" :key="i" class="flex items-center flex-wrap gap-2">
                  <p style="font-size: 12px;" class="w-max rounded px-2 bg-gray-200 text-gray-800 font-bold leading-6">{{ submitUser || $t("exam.unknownUser") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

import GrmTextField from "@/components/Common/textField/GrmTextField.vue";

export default {
  name: 'RoomCBTQuestionChoice',
  components: {
    GrmTextField
  },
  props: {
    index: { type: Number, default: 0 },
    question: { type: Object, default: () => ({}), required: true },
  },
  data() {
    return {
      userAnswerList: [],
    }
  },
  computed: {
    ...mapState('cbt', [
      'roomCBT',
      'showAnswer',
      'roomCBTUserList',
    ]),

    submitUserList() {
      return answer => {
        const submitUserList = [];
        const hasUserQuestionList = this.roomCBTUserList.find(roomCBTUser => roomCBTUser.userQuestionList && roomCBTUser.username);
        if (!hasUserQuestionList) {
          return submitUserList;
        }

        for (let i = 0; i < this.roomCBTUserList.length; i++) {
          const { userQuestionList, username } = this.roomCBTUserList[i];

          if (!userQuestionList) {
            continue;
          }

          for (const userQuestion of userQuestionList) {
            if (userQuestion.questionId === this.question.questionId && userQuestion.userAnswerList?.find(userAnswer => userAnswer.answerId === answer.answerId)) {
              submitUserList.push(username);
            }
          }
        }

        return submitUserList;
      }
    },
  }
}
</script>